/**
 * THE overlay motion family (RD-UI-192): one curve, two feels.
 *  - pop   = centred pop-ups (AnimatedModalShell, confirms): fade + scale .98 -> 1,
 *            220ms in / 200ms out.
 *  - slide = anything that slides (side drawers, full-screen flow on phone, filter
 *            sheet / BottomSheet, the touch row-menu sheet): 300ms in / 160ms out.
 *  - fade  = full-screen flow on desktop: 220ms fade.
 * Reduced motion is handled by each shell (no movement). Never type a duration or
 * curve for an overlay anywhere else — read it from here.
 */
export const OVERLAY_MOTION = {
  easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
  popEnterMs: 220,
  popExitMs: 200,
  popFromScale: 0.98,
  slideEnterMs: 300,
  slideExitMs: 160,
  fadeMs: 220,
  fadeExitMs: 200,
};
